// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-details .bx--tooltip__trigger svg{fill:#525252}.order-details .bx--btn{font-size:14px}.order-details .order-details__menu--order-item__button .bx--btn__icon{width:20px!important;height:20px!important}.bx--assistive-text{font-size:14px!important}", ""]);
// Exports
module.exports = exports;
